import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import BaseRootOption from "%/dynamic-component-editor/classes/base-root-option";

export default class PageDescription extends BaseRootOption {
  static userInterfaceComponent = {
    label: "Description",
    component: inspectorTools.SIMPLE_INPUT,
    useDivider: false,
    useVerticalOrientation: true,
    props: {
      inputType: "textarea",
    },
  };

  static defaultValue = "";
}
